export * from './UIRedDotInformation';
